import { useMedia } from 'react-use';
import { Box } from 'roo-ui/components';
import theme from 'styles/theme';
import ManageBookingActions from './ManageBookingActions';
import DepositPayActions from '../DepositPayActions';

const DesktopManageBookingActions = () => {
  const isDesktop = useMedia(`(min-width: ${theme.breakpoints[1]})`);
  return isDesktop ? (
    <Box p={8} pr={0} mt={7} mr={0} ml="auto" minWidth={theme.minWidths.sidebar}>
      <DepositPayActions />
      <ManageBookingActions />
    </Box>
  ) : null;
};

export default DesktopManageBookingActions;
